/**
 * First we will load all of this project's JavaScript dependencies which
 * includes jQuery and other helpers.
 */

require('./bootstrapSlim');

require('./other');
require('./menu');